import React, { useState, useEffect } from "react";
import "./AdminDashboard.css";
import { getStoredData } from "../../json/fecthData";
import AdminMenu from "../../components/AdminMenu/AdminMenu";
import AdminFunctions from "../../components/AdminFunctions/AdminFunctions";

const AdminDashboard = () => {
  const menuItems = getStoredData()?.[0].Dashboard;
  const Function = getStoredData()?.[0].Functions;

  return (
    <div className="admin-dashboard">
      <AdminMenu menuItems={menuItems} /> 
      <AdminFunctions functions={Function}/>
    </div>
  );
};

export default AdminDashboard;
